import React, { useEffect, useState, useRef } from "react"
import {
   Card,
   Col,
   Container,
   Row,
   Button,
   InputGroup,
   FormControl,
   Form,
} from "react-bootstrap"
import { CSSTransition } from "react-transition-group"
import { fetchAPIData, isLoggedIn, notAuthorized } from "../../api/AuthService"
import { useParams, useNavigate } from "react-router-dom"
import { PREF_MSG, RMPKeys, COMPAREKeys, PART_COMPARE } from "../../constant/Constants"
import Attributes from "./tableComponents/AttributeTable"
import CustomMCTable from "./tableComponents/CustomMCTable"
import CustomPCTable from "./tableComponents/PCTable"
import { errorHandling, handleClick, pdfData } from "../commonComponents/EventHandler"
import GenDocsFileDownTable from "./tableComponents/FileDowload"
import HeaderComponent from "../commonComponents/HeaderComponent"
import PickerSideNav from "./PickerSideNav"
import RefDocDownload from "./tableComponents/RefDocDownload"
import CustomTableATS from "./tableComponents/CustomTableATS"
import LCDerivedTable from "./tableComponents/LCDerivedTable"
import CustomViewPQR from "./tableComponents/CustomViewPQR"
import DownloadTable from "./tableComponents/DownloadTable"
import CustomBOM from "./tableComponents/CustomBOM"

function PartComparison(props) {
   const { objectID } = useParams()
   const navigate = useNavigate()
   const nodeRef = useRef(null)
   const [value, setValue] = useState("")
   const [diffCategories, setDiffCategories] = useState([])
   const [errorMessage, setErrorMessage] = useState("")

   const [data, setData] = useState({
      headerContent: {},
      attributes: {},
      profileIdentification: {},
      physicalProperties: {},
      perfumeProperties: {},
      chemicalMolecularProperties: {},
      detergentSurfactantProperties: {},
      batteryDetails: {},
      weightCharacteristic: [],
      chemicalClassification: {},
      materialsAndComposition: [],
      relatedSpecifications: [],
      masterSpecifications: {},
      referenceDocuments: {},
      performanceCharacteristic: [],
      plants: {},
      rohPlants: [],
      halbPlants: [],
      certificationsMaster: {},
      packagingCertificationsMaster: [],
      pqrViewManufacturer: [],
      pqrSupplierView: [],
      certification: {},
      alternates: [],
      relatedats: [],
      producingformula: [],
      sustainability: {},
      startingmaterials: {},
      rdsites: [],
      lifecycleApprovalPowerview: [],
      ownership: {},
      ipClasses: [],
      security: {},
      organizationsObject: {},
      files: [],
      gpsAssessment: [],
      stabilityDocument: [],
      substancesMaterials: [],
      substitution: {},
      registrationDetails: {},
      billOfMaterials: {},
      notes: {},
      sapBomasFed: {},
      marketOfSale: {},
      revision: {},
      weightsDimensionsObject: {},
      cupArtworks : {},
      batteryCalculation: {},
      billOfMaterialsCustomerUnit: {},
      substitutesConsumerUnit: {},
      bomMasterCunsumerUnit: {},
      substitutes: {},
      bomMasterCustmerUnit: {},
      substitutesMasterConsumerUnit: {},
      substitutesCustomerUnit: {},
      batteryRollUp: {},
      bomInnerPack: {},
      bomMasterInnerPack: {},
      substitutesInnerPack: {},
      substitutesTransportUnit: {},
      substitutesMasterInnerPack: {},
      packingUnit: {},
      baseCodeDetails: {},
      bomTransportUnit: {},
      transportUnit: {},
      storageTransportData: {},
      batteryRollUp: {},
      bomCustmerUnit: {},
      substitutes: {},
      bomConsumerUnit: {},
      substitutesMastesConsumerUnit: {},
      relatedACS: [],
      relatedIAPS: [],
      marketClearance: [],
      relatedSoftwareBuilds: [],
      whereUsed: null,
   })

   const [loading, setLoading] = useState(false)
   const searchData = objectID
   const [sideNav, setSideNav] = useState()

   const [inProp, setInProp] = useState(false)
   const [sideNavOthers, setSideNavOthers] = useState()
   const [selectedItems, setSelectedItems] = useState(COMPAREKeys)
   const [pdfDataSet, setPdfDataSet] = useState({})
   const role = localStorage.getItem("role")

   const handleSelectedItems = (obj, IsFilterView) => {
      setSelectedItems(obj)
      var values = pdfData(data, obj, IsFilterView)
      setPdfDataSet(values)
   }

   async function fetchData() {
      try {
         setLoading(true)
         setInProp(true)
         setSideNav("")

         const response = await fetchAPIData(`${PART_COMPARE}/${value}`)
         const apiData = response.data

         setData((data) => ({
            ...data,
            attributes: apiData.attributes ? apiData.attributes : null,
            profileIdentification: apiData.profileIdentification
               ? apiData.profileIdentification
               : null,
            physicalProperties: apiData.physicalProperties
               ? apiData.physicalProperties
               : null,
            perfumeProperties: apiData.perfumeProperties
               ? apiData.perfumeProperties
               : null,
            chemicalMolecularProperties: apiData.chemicalMolecularProperties
               ? apiData.chemicalMolecularProperties
               : null,
            detergentSurfactantProperties: apiData.detergentSurfactantProperties
               ? apiData.detergentSurfactantProperties
               : null,
            batteryDetails: apiData.batteryDetails ? apiData.batteryDetails : null,
            weightCharacteristic: apiData.weightCharacteristic
               ? apiData.weightCharacteristic
               : null,
            chemicalClassification: apiData.chemicalClassification
               ? apiData.chemicalClassification
               : null,

            materialsAndComposition: apiData.materialsAndComposition
               ? apiData.materialsAndComposition
               : null,
            relatedSpecifications: apiData.relatedSpecifications
               ? apiData.relatedSpecifications
               : null,
            masterSpecifications: apiData.masterSpecifications
               ? apiData.masterSpecifications
               : null,
            referenceDocuments: apiData.referenceDocuments
               ? apiData.referenceDocuments
               : null,
            performanceCharacteristic: apiData.performanceCharacteristic
               ? apiData.performanceCharacteristic
               : null,
            plants: apiData.plants ? apiData.plants : null,
            rohPlants: apiData.rohPlants ? apiData.rohPlants : null,
            halbPlants: apiData.halbPlants ? apiData.halbPlants : null,
            certificationsMaster: apiData.certificationsMaster
               ? apiData.certificationsMaster
               : null,
            packagingCertificationsMaster: apiData.packagingCertificationsMaster
               ? apiData.packagingCertificationsMaster
               : null,
            pqrViewManufacturer: apiData.pqrViewManufacturer
               ? apiData.pqrViewManufacturer
               : null,
            pqrSupplierView: apiData.pqrSupplierView ? apiData.pqrSupplierView : null,
            certification: apiData.certification ? apiData.certification : null,
            alternates: apiData.alternates ? apiData.alternates : null,
            relatedats: apiData.relatedats ? apiData.relatedats : null,
            producingformula: apiData.producingformula ? apiData.producingformula : null,
            substitution: apiData.substitution ? apiData.substitution : null,
            registrationDetails: apiData.registrationDetails
               ? apiData.registrationDetails
               : null,
            billOfMaterials: apiData.billOfMaterials ? apiData.billOfMaterials : null,
            notes: apiData.notes ? apiData.notes : null,
            sapBomasFed: apiData.sapBomasFed ? apiData.sapBomasFed : null,
            marketOfSale: apiData.marketOfSale ? apiData.marketOfSale : null,
            // Others
            startingmaterials: apiData.startingmaterials
               ? apiData.startingmaterials
               : null,
            rdsites: apiData.rdsites ? apiData.rdsites : null,
            lifecycleApprovalPowerview: apiData.lifecycleApprovalPowerview
               ? apiData.lifecycleApprovalPowerview
               : null,
            ownership: apiData.ownership ? apiData.ownership : null,
            ipClasses: apiData.ipClasses ? apiData.ipClasses : null,
            security: apiData.security ? apiData.security : null,
            organizationsObject: apiData.organizationsObject
               ? apiData.organizationsObject
               : null,
            files: apiData.files ? apiData.files : null,
            gpsAssessment: apiData.gpsAssessment ? apiData.gpsAssessment : null,
            sustainability: apiData.sustainability ? apiData.sustainability : null,
            stabilityDocument: apiData.stabilityDocument
               ? apiData.stabilityDocument
               : null,
            substancesMaterials: apiData.substancesMaterials
               ? apiData.substancesMaterials
               : null,
            revision: apiData.revision ? apiData.revision : null,
            weightsDimensionsObject: apiData.weightsDimensionsObject 
               ? apiData.weightsDimensionsObject 
               : null,
            cupArtworks : apiData.cupArtworks  ? apiData.cupArtworks : null,
            batteryCalculation: apiData.batteryCalculation
               ? apiData.batteryCalculation
               : null,
            billOfMaterialsCustomerUnit: apiData.bomCustmerUnit
               ? apiData.bomCustmerUnit
               : null,
            substitutesConsumerUnit: apiData.substitutesConsumerUnit
               ? apiData.substitutesConsumerUnit
               : null,
            bomMasterCunsumerUnit: apiData.bomMasterCunsumerUnit
               ? apiData.bomMasterCunsumerUnit
               : null,
            substitutes: apiData.substitutes ? apiData.substitutes : null,
            bomMasterCustmerUnit: apiData.bomMasterCustmerUnit
               ? apiData.bomMasterCustmerUnit
               : null,
            substitutesMasterConsumerUnit: apiData.substitutesMasterConsumerUnit
               ? apiData.substitutesMasterConsumerUnit
               : null,
            substitutesCustomerUnit: apiData.substitutesCustomerUnit
               ? apiData.substitutesCustomerUnit
               : null,
            batteryRollUp: apiData.batteryRollUp ? apiData.batteryRollUp : null,
            bomInnerPack: apiData.bomInnerPack ? apiData.bomInnerPack : null,
            bomMasterInnerPack: apiData.bomMasterInnerPack
               ? apiData.bomMasterInnerPack
               : null,
            substitutesInnerPack: apiData.substitutesInnerPack
               ? apiData.substitutesInnerPack
               : null,
            substitutesTransportUnit: apiData.substitutesTransportUnit
               ? apiData.substitutesTransportUnit
               : null,
            substitutesMasterInnerPack: apiData.substitutesMasterInnerPack
               ? apiData.substitutesMasterInnerPack
               : null,
            baseCodeDetails: apiData.baseCodeDetails
               ? apiData.baseCodeDetails
               : null,
            bomTransportUnit: apiData.bomTransportUnit
               ? apiData.bomTransportUnit
               : null,
            transportUnit: apiData.transportUnit ? apiData.transportUnit : null,
            packingUnit: apiData.packingUnit ? apiData.packingUnit : null,
            storageTransportData: apiData.storageTransportData
               ? apiData.storageTransportData
               : null,
            batteryRollUp: apiData.batteryRollUp ? apiData.batteryRollUp : null,
            substitutes: apiData.substitutes ? apiData.substitutes : null,
            bomConsumerUnit: apiData.bomConsumerUnit ? apiData.bomConsumerUnit : null,
            substitutesMastesConsumerUnit: apiData.substitutesMastesConsumerUnit
               ? apiData.substitutesMastesConsumerUnit
               : null,
            relatedACS: apiData.relatedACS ? apiData.relatedACS : null,
            relatedIAPS: apiData.relatedIAPS ? apiData.relatedIAPS : null,
            marketClearance: apiData.marketClearance ? apiData.marketClearance : null,
            relatedSoftwareBuilds: apiData.relatedSoftwareBuilds ? apiData.relatedSoftwareBuilds : null,
            whereUsed: apiData.whereUsed ? apiData.whereUsed : null,
         }))
         setLoading(false)
         setNavigation()
      } catch (error) {
         if (error.response) {
            let status = error.response.data.status
            if (
               status === 403 ||
               status === 404 ||
               status === 409 ||
               status === 500 ||
               status === 501
            ) {
               setErrorMessage(error.response.data.message)
               setLoading(false)
               setInProp(false)
               setData({})
               return
            }
         }
         setLoading(false)
         errorHandling(error, navigate)
      }
   }

   useEffect(() => {
      if (!isLoggedIn()) {
          navigate("/")
      } else {
         // fetchFppData()
         window.scrollTo(0, 0)
      }
      return () => {
         return undefined
      }
   }, [searchData, navigate, data])

   function handleSearchChange(e) {
      setValue(e.target.value)
      setErrorMessage("")
   }

   function handleCompare(e) {
      e.preventDefault()
      if (value.length < 8) {
         setErrorMessage("Please enter a valid part number")
         return
      } else {
         fetchData()
      }
   }

   const handleDiffCategory = (category) => {
      setDiffCategories((prev) => {
         if (!prev.includes(category)) {
            return [...prev, category]
         }
         return prev
      })
   }

   const hasAnyValidData = () => {
      const dataKeys = Object.keys(data);
      
      return dataKeys.some(key => {
         if (key === 'headerContent' || key === 'whereUsed') return false;
         const value = data[key];
         if (value == null) return false;
         if (Array.isArray(value)) {
            return value.length > 0;
         }
         if (typeof value === 'object') {
            if (value.hasOwnProperty('release') || value.hasOwnProperty('obsolete')) {
               return (value.release && Object.keys(value.release).length > 0) ||
                     (value.obsolete && Object.keys(value.obsolete).length > 0);
            }
            return Object.keys(value).length > 0;
         }
         return value !== '' && value !== 0;
      });
   };

   return (
      <React.Fragment>
         <HeaderComponent />
         <div className="compareContent">
            <Row>
               <Col>
                  <div
                     style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "20px",
                     }}
                  >
                     <div
                        style={{
                           color: "white",
                           margin: "8px 8px 8px 0px",
                        }}
                     >
                        Compare :
                     </div>
                     <div
                        style={{
                           verticalAlign: "middle",
                           textAlign: "left",
                           float: "left",
                        }}
                     >
                        <Form onSubmit={(e) => handleCompare(e)}>
                           <InputGroup>
                              <FormControl
                                 style={{ height: "35px" }}
                                 id="search"
                                 className={`placeHolderText searchBox shadow`}
                                 type="text"
                                 placeholder="&#61442; Please enter part number"
                                 onChange={handleSearchChange}
                                 value={value}
                              />
                              
                                 <Button bsPrefix="searchBtnText_copy" type="submit" style={{ height: "35px" }}>
                                    <i className="fa fa-search"></i>
                                 </Button>
                              
                           </InputGroup>
                        </Form>
                     </div>
                  </div>
               </Col>
            </Row>
         </div>
         {errorMessage && (
            <Col md={{ span: 10, offset: 1 }} className="partErrorMessage">
               <span style={{ color: "white", textAlign: "center" }}>{errorMessage}</span>
            </Col>
         )}
         {loading ? (
            <h2 style={{ textAlign: "center", color: "white" }}>
               <i className="fa fa-spinner fa-spin" style={{ marginRight: "5px" }} />
               Loading........
            </h2>
         ) : (
            <CSSTransition timeout={300} in={inProp} classNames="my-node" nodeRef={nodeRef}>
               <Container fluid ref={nodeRef}>
                  {hasAnyValidData() && errorMessage.length === 0 ? (
                     <Row>
                        <Col md="12">
                           <PickerSideNav
                              data={sideNav}
                              dataOther={sideNavOthers}
                              dataRevision={data.revision}
                              resData={data}
                              Keys={COMPAREKeys}
                              whereUsed={data.whereUsed}
                              diffCategories={diffCategories}
                              partName={value}
                           />
                        </Col>

                        <Col md="12" className="contentBackground">
                           <Row>
                              <Col
                                 autoFocus
                                 md="12"
                                 className="dataCol contentBackground"
                              >
                                 {!loading &&
                                    data.attributes &&
                                    selectedItems["attributes"] && (
                                       <div id="0" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="Zero"
                                             >
                                                {COMPAREKeys.attributes}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="Zero"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                loading={loading}
                                                data={data.attributes}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.attributes}
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}

                                 {!loading &&
                                    data.storageTransportData &&
                                    selectedItems["storageTransportData"] && (
                                       <div id="59" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="fiftyNine"
                                             >
                                                {COMPAREKeys.storageTransportData}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="fiftyNine"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                loading={loading}
                                                data={data.storageTransportData}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.storageTransportData}
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}

                                    {!loading && data.stabilityDocument && selectedItems["stabilityDocument"] && (
                                       <div id="60" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="sixty"
                                             >
                                                {COMPAREKeys.stabilityDocument}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="sixty"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.stabilityDocument["release"]}
                                                previousData={data.stabilityDocument["obsolete"]}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.stabilityDocument}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.batteryRollUp &&
                                    selectedItems["batteryRollUp"] && (
                                       <div id="33" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="thirtyThree"
                                             >
                                                {COMPAREKeys.batteryRollUp}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="thirtyThree"
                                             name="collapseItem"
                                          >
                                             <CustomViewPQR
                                                data={
                                                   data.batteryRollUp["release"]
                                                }
                                                previousData={
                                                   data.batteryRollUp["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.batteryRollUp}
                                                revision={data.revision}
                                                partName={value}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.profileIdentification &&
                                    selectedItems["profileIdentification"] && (
                                       <div id="1" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="One"
                                             >
                                                {COMPAREKeys.profileIdentification}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="One"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                data={data.profileIdentification}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.profileIdentification}
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.physicalProperties &&
                                    selectedItems["physicalProperties"] && (
                                       <div id="2" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="Two"
                                             >
                                                {COMPAREKeys.physicalProperties}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="Two"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                data={data.physicalProperties}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.physicalProperties}
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.perfumeProperties &&
                                    selectedItems["perfumeProperties"] && (
                                       <div id="3" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="Three"
                                             >
                                                {COMPAREKeys.perfumeProperties}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="Three"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                data={data.perfumeProperties}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.perfumeProperties}
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.chemicalMolecularProperties &&
                                    selectedItems["chemicalMolecularProperties"] && (
                                       <div id="4" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="Four"
                                             >
                                                {COMPAREKeys.chemicalMolecularProperties}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="Four"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                data={data.chemicalMolecularProperties}
                                                handleDiffCategory={handleDiffCategory}
                                                name={
                                                   COMPAREKeys.chemicalMolecularProperties
                                                }
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.detergentSurfactantProperties &&
                                    selectedItems["detergentSurfactantProperties"] && (
                                       <div id="5" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="Five"
                                             >
                                                {
                                                   COMPAREKeys.detergentSurfactantProperties
                                                }
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="Five"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                data={data.detergentSurfactantProperties}
                                                handleDiffCategory={handleDiffCategory}
                                                name={
                                                   COMPAREKeys.detergentSurfactantProperties
                                                }
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.batteryDetails &&
                                    selectedItems["batteryDetails"] && (
                                       <div id="6" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="six"
                                             >
                                                {COMPAREKeys.batteryDetails}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="six"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                data={data.batteryDetails}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.batteryDetails}
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.weightCharacteristic &&
                                    selectedItems["weightCharacteristic"] && (
                                       <div id="7" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="seven"
                                             >
                                                {COMPAREKeys.weightCharacteristic}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="seven"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                data={data.weightCharacteristic}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.weightCharacteristic}
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.chemicalClassification &&
                                    selectedItems["chemicalClassification"] && (
                                       <div id="8" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="eight"
                                             >
                                                {COMPAREKeys.chemicalClassification}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="eight"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                data={data.chemicalClassification}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.chemicalClassification}
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.materialsAndComposition &&
                                    selectedItems["materialsAndComposition"] && (
                                       <div id="10" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="ten"
                                             >
                                                {COMPAREKeys.materialsAndComposition}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="ten"
                                             name="collapseItem"
                                          >
                                             <CustomMCTable
                                                data={
                                                   data.materialsAndComposition["release"]
                                                }
                                                previousData={
                                                   data.materialsAndComposition[
                                                      "obsolete"
                                                   ]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.materialsAndComposition}
                                                revision={data.revision}
                                                partName={value}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.relatedSpecifications &&
                                    selectedItems["relatedSpecifications"] && (
                                       <div id="11" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="elevan"
                                             >
                                                {COMPAREKeys.relatedSpecifications}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="elevan"
                                             name="collapseItem"
                                          >
                                             <DownloadTable
                                                data={
                                                   data.relatedSpecifications["release"]
                                                }
                                                previousData={
                                                   data.relatedSpecifications["obsolete"]
                                                }
                                                revision={data.revision}
                                                partName={value}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.relatedSpecifications}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.masterSpecifications &&
                                    selectedItems["masterSpecifications"] && (
                                       <div id="12" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="twelve"
                                             >
                                                {COMPAREKeys.masterSpecifications}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="twelve"
                                             name="collapseItem"
                                          >
                                             <CustomViewPQR
                                                data={
                                                   data.masterSpecifications["release"]
                                                }
                                                previousData={
                                                   data.masterSpecifications["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.masterSpecifications}
                                                revision={data.revision}
                                                partName={value}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.referenceDocuments &&
                                    selectedItems["referenceDocuments"] && (
                                       <div id="13" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="thirteen"
                                             >
                                                {COMPAREKeys.referenceDocuments}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="thirteen"
                                             name="collapseItem"
                                          >
                                             <RefDocDownload
                                                data={data.referenceDocuments["release"]}
                                                previousData={
                                                   data.referenceDocuments["obsolete"]
                                                }
                                                attributes={data.attributes}
                                                headerContent={data.headerContent}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.referenceDocuments}
                                                revision={data.revision}
                                                partName={value}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.performanceCharacteristic &&
                                    selectedItems["performanceCharacteristic"] && (
                                       <div id="14" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="fourteen"
                                             >
                                                {COMPAREKeys.performanceCharacteristic}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="fourteen"
                                             name="collapseItem"
                                          >
                                             <CustomPCTable
                                                data={
                                                   data.performanceCharacteristic[
                                                      "release"
                                                   ]
                                                }
                                                previousData={
                                                   data.performanceCharacteristic[
                                                      "obsolete"
                                                   ]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={
                                                   COMPAREKeys.performanceCharacteristic
                                                }
                                                revision={data.revision}
                                                partName={value}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading && data.plants && selectedItems["plants"] && (
                                    <div id="34" className="PartComparision">
                                       <Card>
                                          <Card.Body
                                             className="accordionStyle"
                                             aria-controls="thirtyfour"
                                          >
                                             {COMPAREKeys.plants}{" "}
                                          </Card.Body>
                                       </Card>
                                       <div
                                          className="accordionDiv shadow"
                                          id="thirtyfour"
                                          name="collapseItem"
                                       >
                                          <CustomTableATS
                                             revision={data.revision}
                                             partName={value}
                                             data={data.plants["release"]}
                                             previousData={data.plants["obsolete"]}
                                             handleDiffCategory={handleDiffCategory}
                                             name={COMPAREKeys.plants}
                                          />
                                       </div>
                                    </div>
                                 )}

                                 {!loading &&
                                    data.weightsDimensionsObject != null &&
                                    selectedItems["weightsDimensionsObject"] && (
                                       <div id="36" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="thirtysix"
                                             >
                                                {COMPAREKeys.weightsDimensionsObject}{" "}
                                                
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="thirtysix"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <Attributes
                                                loading={loading}
                                                data={data.weightsDimensionsObject}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.weightsDimensionsObject}
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}

                                 {!loading &&
                                    data.rohPlants &&
                                    selectedItems["rohPlants"] && (
                                       <div id="15" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="fifteen"
                                             >
                                                {COMPAREKeys.rohPlants}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="fifteen"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.rohPlants["release"]}
                                                previousData={data.rohPlants["obsolete"]}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.rohPlants}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.halbPlants &&
                                    selectedItems["halbPlants"] && (
                                       <div id="9" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="none"
                                             >
                                                {COMPAREKeys.halbPlants}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="nine"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.halbPlants["release"]}
                                                previousData={data.halbPlants["obsolete"]}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.halbPlants}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.certificationsMaster &&
                                    selectedItems["certificationsMaster"] && (
                                       <div id="16" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="Sixteen"
                                             >
                                                {COMPAREKeys.certificationsMaster}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="Sixteen"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={
                                                   data.certificationsMaster["release"]
                                                }
                                                previousData={
                                                   data.certificationsMaster["obsolete"]
                                                }
                                                releaseHeader={
                                                   data.certificationsMaster[
                                                      "releaseHeader"
                                                   ]
                                                }
                                                obsoleteHeader={
                                                   data.certificationsMaster[
                                                      "obsoleteHeader"
                                                   ]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.certificationsMaster}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.packagingCertificationsMaster &&
                                    selectedItems["packagingCertificationsMaster"] && (
                                       <div id="50" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="Sixteen"
                                             >
                                                {
                                                   COMPAREKeys.packagingCertificationsMaster
                                                }{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="Sixteen"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={
                                                   data.packagingCertificationsMaster[
                                                      "release"
                                                   ]
                                                }
                                                previousData={
                                                   data.packagingCertificationsMaster[
                                                      "obsolete"
                                                   ]
                                                }
                                                releaseHeader={
                                                   data.packagingCertificationsMaster[
                                                      "releaseHeader"
                                                   ]
                                                }
                                                obsoleteHeader={
                                                   data.packagingCertificationsMaster[
                                                      "obsoleteHeader"
                                                   ]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={
                                                   COMPAREKeys.packagingCertificationsMaster
                                                }
                                             />
                                          </div>
                                       </div>
                                    )}

                                 {!loading &&
                                    data.pqrViewManufacturer &&
                                    selectedItems["pqrViewManufacturer"] && (
                                       <div id="17" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="seventeen"
                                             >
                                                {COMPAREKeys.pqrViewManufacturer}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="seventeen"
                                             name="collapseItem"
                                          >
                                             <CustomViewPQR
                                                data={data.pqrViewManufacturer["release"]}
                                                previousData={
                                                   data.pqrViewManufacturer["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.pqrViewManufacturer}
                                                view="manufacturer"
                                                revision={data.revision}
                                                partName={value}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.pqrSupplierView &&
                                    selectedItems["pqrSupplierView"] && (
                                       <div id="18" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="eighteen"
                                             >
                                                {COMPAREKeys.pqrSupplierView}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="eighteen"
                                             name="collapseItem"
                                          >
                                             <CustomViewPQR
                                                data={data.pqrSupplierView["release"]}
                                                previousData={
                                                   data.pqrSupplierView["obsolete"]
                                                }
                                                view="supplier"
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.pqrSupplierView}
                                                revision={data.revision}
                                                partName={value}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.certification &&
                                    selectedItems["certification"] && (
                                       <div id="19" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="nineteen"
                                             >
                                                {COMPAREKeys.certification}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="nineteen"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.certification["release"]}
                                                previousData={
                                                   data.certification["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.certification}
                                             />
                                          </div>
                                       </div>
                                    )}

                                 {!loading &&
                                    data.alternates &&
                                    selectedItems["alternates"] && (
                                       <div id="20" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="twenty"
                                             >
                                                {COMPAREKeys.alternates}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="twenty"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.alternates["release"]}
                                                previousData={data.alternates["obsolete"]}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.alternates}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.relatedats &&
                                    selectedItems["relatedats"] && (
                                       <div id="21" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="twentyone"
                                             >
                                                {COMPAREKeys.relatedats}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="twentyone"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.relatedats["release"]}
                                                previousData={data.relatedats["obsolete"]}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.relatedats}
                                             />
                                          </div>
                                       </div>
                                    )}
                                    {!loading &&
                                    data.relatedACS &&
                                    selectedItems["relatedACS"] && (
                                       <div id="42" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="fortyTwo"
                                             >
                                                {COMPAREKeys.relatedACS}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="fortyTwo"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.relatedACS["release"]}
                                                previousData={data.relatedACS["obsolete"]}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.relatedACS}
                                             />
                                          </div>
                                       </div>
                                    )}
                                    {!loading &&
                                    data.relatedIAPS &&
                                    selectedItems["relatedIAPS"] && (
                                       <div id="43" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="fortyThree"
                                             >
                                                {COMPAREKeys.relatedIAPS}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="fortyThree"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.relatedIAPS["release"]}
                                                previousData={data.relatedIAPS["obsolete"]}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.relatedIAPS}
                                             />
                                          </div>
                                       </div>
                                    )}
                                    {!loading &&
                                    data.marketClearance &&
                                    selectedItems["marketClearance"] && (
                                       <div id="44" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="fortyFour"
                                             >
                                                {COMPAREKeys.marketClearance}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="fortyFour"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.marketClearance["release"]}
                                                previousData={data.marketClearance["obsolete"]}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.marketClearance}
                                             />
                                          </div>
                                       </div>
                                    )}
                                    {!loading &&
                                    data.relatedSoftwareBuilds &&
                                    selectedItems["relatedSoftwareBuilds"] && (
                                       <div id="45" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="fortyFive"
                                             >
                                                {COMPAREKeys.relatedSoftwareBuilds}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="fortyFive"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.relatedSoftwareBuilds["release"]}
                                                previousData={data.relatedSoftwareBuilds["obsolete"]}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.relatedSoftwareBuilds}
                                             />
                                          </div>
                                       </div>
                                    )}
                                    {!loading &&
                                       data.packingUnit &&
                                       selectedItems["packingUnit"] && (
                                          <div id="56" className="PartComparision">
                                             <Card>
                                                <Card.Body
                                                   className="accordionStyle"
                                                   aria-controls="fiftysix"
                                                >
                                                   {COMPAREKeys.packingUnit}
                                                </Card.Body>
                                             </Card>
                                             <div
                                                className="accordionDiv shadow"
                                                id="fiftysix"
                                                name="collapseItem"
                                             >
                                                <CustomViewPQR
                                                   data={data.packingUnit["release"]}
                                                   previousData={
                                                      data.packingUnit["obsolete"]
                                                   }
                                                   handleDiffCategory={handleDiffCategory}
                                                   name={COMPAREKeys.packingUnit}
                                                   revision={data.revision}
                                                   partName={value}
                                                />
                                             </div>
                                          </div>
                                       )}
                                    {!loading &&
                                       data.transportUnit &&
                                       selectedItems["transportUnit"] && (
                                          <div id="55" className="PartComparision">
                                             <Card>
                                                <Card.Body
                                                   className="accordionStyle"
                                                   aria-controls="fiftyfive"
                                                >
                                                   {COMPAREKeys.transportUnit}
                                                </Card.Body>
                                             </Card>
                                             <div
                                                className="accordionDiv shadow"
                                                id="fiftyfive"
                                                name="collapseItem"
                                             >
                                                <CustomViewPQR
                                                   data={data.transportUnit["release"]}
                                                   previousData={
                                                      data.transportUnit["obsolete"]
                                                   }
                                                   handleDiffCategory={handleDiffCategory}
                                                   name={COMPAREKeys.transportUnit}
                                                   revision={data.revision}
                                                   partName={value}
                                                />
                                             </div>
                                          </div>
                                       )}
                                    {!loading &&
                                       data.baseCodeDetails &&
                                       selectedItems["baseCodeDetails"] && (
                                          <div id="54" className="PartComparision">
                                             <Card>
                                                <Card.Body
                                                   className="accordionStyle"
                                                   aria-controls="fiftyfour"
                                                >
                                                   {COMPAREKeys.baseCodeDetails}
                                                </Card.Body>
                                             </Card>
                                             <div
                                                className="accordionDiv shadow"
                                                id="fiftyfour"
                                                name="collapseItem"
                                             >
                                                <CustomBOM
                                                   revision={data.revision}
                                                   partName={value}
                                                   data={data.baseCodeDetails["release"]}
                                                   previousData={
                                                      data.baseCodeDetails["obsolete"]
                                                   }
                                                   handleDiffCategory={handleDiffCategory}
                                                   name={COMPAREKeys.baseCodeDetails}
                                                />
                                             </div>
                                          </div>
                                       )}
                                 {!loading &&
                                    data.producingformula &&
                                    selectedItems["producingformula"] && (
                                       <div id="22" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="twentytwo"
                                             >
                                                {COMPAREKeys.producingformula}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="twentytwo"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.producingformula["release"]}
                                                previousData={
                                                   data.producingformula["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.producingformula}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.sustainability &&
                                    selectedItems["sustainability"] && (
                                       <div id="32" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="thirtytwo"
                                             >
                                                {COMPAREKeys.sustainability}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="thirtytwo"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                data={data.sustainability}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.sustainability}
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}

                                 {!loading &&
                                    data.substitution &&
                                    selectedItems["substitution"] && (
                                       <div id="35" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="thirtyfive"
                                             >
                                                {COMPAREKeys.substitution}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="thirtyfive"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.substitution["release"]}
                                                previousData={
                                                   data.substitution["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.substitution}
                                             />
                                          </div>
                                       </div>
                                    )}

                                 {!loading &&
                                    data.registrationDetails &&
                                    selectedItems["registrationDetails"] && (
                                       <div id="37" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="thirtyseven"
                                             >
                                                {COMPAREKeys.registrationDetails}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="thirtyseven"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomViewPQR
                                                revision={data.revision}
                                                partName={value}
                                                data={data.registrationDetails["release"]}
                                                previousData={
                                                   data.registrationDetails["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.registrationDetails}
                                             />
                                          </div>
                                       </div>
                                    )}

                                 {!loading &&
                                    data.billOfMaterials &&
                                    selectedItems["billOfMaterials"] && (
                                       <div id="38" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="thirtyeight"
                                             >
                                                {COMPAREKeys.billOfMaterials}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="thirtyeight"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomBOM
                                                revision={data.revision}
                                                partName={value}
                                                data={data.billOfMaterials["release"]}
                                                previousData={
                                                   data.billOfMaterials["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.billOfMaterials}
                                             />
                                          </div>
                                       </div>
                                    )}

                                    {!loading &&
                                    data.substitutes &&
                                    selectedItems["substitutes"] && (
                                       <div id="69" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="sixtyNine"
                                             >
                                                {COMPAREKeys.substitutes}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="sixtyNine"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomBOM
                                                revision={data.revision}
                                                partName={value}
                                                data={data.substitutes["release"]}
                                                previousData={
                                                   data.substitutes["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.substitutes}
                                             />
                                          </div>
                                       </div>
                                    )}
                                    {!loading &&
                                       data.bomMasterCunsumerUnit &&
                                       selectedItems["bomMasterCunsumerUnit"] && (
                                          <div id="51" className="PartComparision">
                                             <Card>
                                                <Card.Body
                                                   className="accordionStyle"
                                                   
                                                   aria-controls="fifty"
                                                >
                                                   {COMPAREKeys.bomMasterCunsumerUnit}{" "}
                                                   
                                                </Card.Body>
                                             </Card>
                                             <div
                                                className="accordionDiv shadow"
                                                id="fifty"
                                                name="collapseItem"
                                                style={{ display: "block" }}
                                             >
                                                <CustomBOM
                                                   revision={data.revision}
                                                   partName={value}
                                                   data={data.bomMasterCunsumerUnit["release"]}
                                                   previousData={
                                                      data.bomMasterCunsumerUnit["obsolete"]
                                                   }
                                                   handleDiffCategory={handleDiffCategory}
                                                   name={COMPAREKeys.bomMasterCunsumerUnit}
                                                />
                                             </div>
                                          </div>
                                       )}
                                 {!loading &&
                                    data.billOfMaterialsCustomerUnit &&
                                    selectedItems["billOfMaterialsCustomerUnit"] && (
                                       <div id="49" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="fortyNine"
                                             >
                                                {COMPAREKeys.billOfMaterialsCustomerUnit}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="fortyNine"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomBOM
                                                revision={data.revision}
                                                partName={value}
                                                data={data.billOfMaterialsCustomerUnit["release"]}
                                                previousData={
                                                   data.billOfMaterialsCustomerUnit["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.billOfMaterialsCustomerUnit}
                                             />
                                          </div>
                                       </div>
                                    )}
                                    {!loading &&
                                    data.bomConsumerUnit &&
                                    selectedItems["bomConsumerUnit"] && (
                                       <div id="70" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="seventy"
                                             >
                                                {COMPAREKeys.bomConsumerUnit}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="seventy"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomBOM
                                                revision={data.revision}
                                                partName={value}
                                                data={data.bomConsumerUnit["release"]}
                                                previousData={
                                                   data.bomConsumerUnit["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.bomConsumerUnit}
                                             />
                                          </div>
                                       </div>
                                    )}
                                    {!loading &&
                                    data.substitutesMasterConsumerUnit &&
                                    selectedItems["substitutesMasterConsumerUnit"] && (
                                       <div id="64" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="sixtyFour"
                                             >
                                                {COMPAREKeys.substitutesMasterConsumerUnit}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="sixtyFour"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomBOM
                                                revision={data.revision}
                                                partName={value}
                                                data={data.substitutesMasterConsumerUnit["release"]}
                                                previousData={
                                                   data.substitutesMasterConsumerUnit["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.substitutesMasterConsumerUnit}
                                             />
                                          </div>
                                       </div>
                                    )}
                                    {!loading &&
                                       data.substitutesCustomerUnit &&
                                       selectedItems["substitutesCustomerUnit"] && (
                                          <div id="61" className="PartComparision">
                                             <Card>
                                                <Card.Body
                                                   className="accordionStyle"
                                                   aria-controls="sixtyOne"
                                                >
                                                   {COMPAREKeys.substitutesCustomerUnit}{" "}
                                                </Card.Body>
                                             </Card>
                                             <div
                                                className="accordionDiv shadow"
                                                id="sixtyOne"
                                                name="collapseItem"
                                                style={{ display: "block" }}
                                             >
                                                <CustomBOM
                                                   revision={data.revision}
                                                   partName={value}
                                                   data={data.substitutesCustomerUnit["release"]}
                                                   previousData={
                                                      data.substitutesCustomerUnit["obsolete"]
                                                   }
                                                   handleDiffCategory={handleDiffCategory}
                                                   name={COMPAREKeys.substitutesCustomerUnit}
                                                />
                                             </div>
                                          </div>
                                       )}
                                    {!loading &&
                                    data.bomTransportUnit &&
                                    selectedItems["bomTransportUnit"] && (
                                       <div id="58" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="fiftyeight"
                                             >
                                                {COMPAREKeys.bomTransportUnit}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="fiftyeight"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomBOM
                                                revision={data.revision}
                                                partName={value}
                                                data={data.bomTransportUnit["release"]}
                                                previousData={
                                                   data.bomTransportUnit["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.bomTransportUnit}
                                             />
                                          </div>
                                       </div>
                                    )}
                                    {!loading &&
                                       data.substitutesTransportUnit &&
                                       selectedItems["substitutesTransportUnit"] && (
                                          <div id="67" className="PartComparision">
                                             <Card>
                                                <Card.Body
                                                   className="accordionStyle"
                                                   aria-controls="sixtySeven"
                                                >
                                                   {COMPAREKeys.substitutesTransportUnit}{" "}
                                                </Card.Body>
                                             </Card>
                                             <div
                                                className="accordionDiv shadow"
                                                id="sixtySeven"
                                                name="collapseItem"
                                                style={{ display: "block" }}
                                             >
                                                <CustomBOM
                                                   revision={data.revision}
                                                   partName={value}
                                                   data={data.substitutesTransportUnit["release"]}
                                                   previousData={
                                                      data.substitutesTransportUnit["obsolete"]
                                                   }
                                                   handleDiffCategory={handleDiffCategory}
                                                   name={COMPAREKeys.substitutesTransportUnit}
                                                />
                                             </div>
                                          </div>
                                       )}
                                       {!loading &&
                                          data.bomMasterCustmerUnit &&
                                          selectedItems["bomMasterCustmerUnit"] && (
                                             <div id="62" className="PartComparision">
                                                <Card>
                                                   <Card.Body
                                                      className="accordionStyle"
                                                      aria-controls="sixtyTwo"
                                                   >
                                                      {COMPAREKeys.bomMasterCustmerUnit}{" "}
                                                   </Card.Body>
                                                </Card>
                                                <div
                                                   className="accordionDiv shadow"
                                                   id="sixtyTwo"
                                                   name="collapseItem"
                                                   style={{ display: "block" }}
                                                >
                                                   <CustomBOM
                                                      revision={data.revision}
                                                      partName={value}
                                                      data={data.bomMasterCustmerUnit["release"]}
                                                      previousData={
                                                         data.bomMasterCustmerUnit["obsolete"]
                                                      }
                                                      handleDiffCategory={handleDiffCategory}
                                                      name={COMPAREKeys.bomMasterCustmerUnit}
                                                   />
                                                </div>
                                             </div>
                                          )}
                                 {!loading &&
                                    data.bomInnerPack &&
                                    selectedItems["bomInnerPack"] && (
                                       <div id="53" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="fiftythree"
                                             >
                                                {COMPAREKeys.bomInnerPack}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="fiftythree"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomBOM
                                                revision={data.revision}
                                                partName={value}
                                                data={data.bomInnerPack["release"]}
                                                previousData={
                                                   data.bomInnerPack["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.bomInnerPack}
                                             />
                                          </div>
                                       </div>
                                    )}

                                    {!loading &&
                                       data.bomMasterInnerPack &&
                                       selectedItems["bomMasterInnerPack"] && (
                                          <div id="63" className="PartComparision">
                                             <Card>
                                                <Card.Body
                                                   className="accordionStyle"
                                                   aria-controls="sixtythree"
                                                >
                                                   {COMPAREKeys.bomMasterInnerPack}{" "}
                                                </Card.Body>
                                             </Card>
                                             <div
                                                className="accordionDiv shadow"
                                                id="sixtythree"
                                                name="collapseItem"
                                                style={{ display: "block" }}
                                             >
                                                <CustomBOM
                                                   revision={data.revision}
                                                   partName={value}
                                                   data={data.bomMasterInnerPack["release"]}
                                                   previousData={
                                                      data.bomMasterInnerPack["obsolete"]
                                                   }
                                                   handleDiffCategory={handleDiffCategory}
                                                   name={COMPAREKeys.bomMasterInnerPack}
                                                />
                                             </div>
                                          </div>
                                       )}
                                    {!loading &&
                                       data.substitutesMasterInnerPack &&
                                       selectedItems["substitutesMasterInnerPack"] && (
                                          <div id="65" className="PartComparision">
                                             <Card>
                                                <Card.Body
                                                   className="accordionStyle"
                                                   aria-controls="sixtyfive"
                                                >
                                                   {COMPAREKeys.substitutesMasterInnerPack}{" "}
                                                </Card.Body>
                                             </Card>
                                             <div
                                                className="accordionDiv shadow"
                                                id="sixtyfive"
                                                name="collapseItem"
                                                style={{ display: "block" }}
                                             >
                                                <CustomBOM
                                                   revision={data.revision}
                                                   partName={value}
                                                   data={data.substitutesMasterInnerPack["release"]}
                                                   previousData={
                                                      data.substitutesMasterInnerPack["obsolete"]
                                                   }
                                                   handleDiffCategory={handleDiffCategory}
                                                   name={COMPAREKeys.substitutesMasterInnerPack}
                                                />
                                             </div>
                                          </div>
                                       )}
                                       {!loading &&
                                          data.substitutesMastesConsumerUnit &&
                                          selectedItems["substitutesMastesConsumerUnit"] && (
                                             <div id="66" className="PartComparision">
                                                <Card>
                                                   <Card.Body
                                                      className="accordionStyle"
                                                      aria-controls="sixtySix"
                                                   >
                                                      {COMPAREKeys.substitutesMastesConsumerUnit}{" "}
                                                   </Card.Body>
                                                </Card>
                                                <div
                                                   className="accordionDiv shadow"
                                                   id="sixtySix"
                                                   name="collapseItem"
                                                   style={{ display: "block" }}
                                                >
                                                   <CustomBOM
                                                      revision={data.revision}
                                                      partName={value}
                                                      data={data.substitutesMastesConsumerUnit["release"]}
                                                      previousData={
                                                         data.substitutesMastesConsumerUnit["obsolete"]
                                                      }
                                                      handleDiffCategory={handleDiffCategory}
                                                      name={COMPAREKeys.substitutesMastesConsumerUnit}
                                                   />
                                                </div>
                                             </div>
                                          )}
                                    {!loading &&
                                       data.substitutesConsumerUnit &&
                                       selectedItems["substitutesConsumerUnit"] && (
                                          <div id="52" className="PartComparision">
                                             <Card>
                                                <Card.Body
                                                   className="accordionStyle"
                                                   aria-controls="fiftytwo"
                                                >
                                                   {COMPAREKeys.substitutesConsumerUnit}{" "}
                                                </Card.Body>
                                             </Card>
                                             <div
                                                className="accordionDiv shadow"
                                                id="fiftytwo"
                                                name="collapseItem"
                                                style={{ display: "block" }}
                                             >
                                                <CustomBOM
                                                   revision={data.revision}
                                                   partName={value}
                                                   data={data.substitutesConsumerUnit["release"]}
                                                   previousData={
                                                      data.substitutesConsumerUnit["obsolete"]
                                                   }
                                                   handleDiffCategory={handleDiffCategory}
                                                   name={COMPAREKeys.substitutesConsumerUnit}
                                                />
                                             </div>
                                          </div>
                                       )}

                                    {!loading &&
                                    data.substitutesInnerPack &&
                                    selectedItems["substitutesInnerPack"] && (
                                       <div id="57" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="fiftyseven"
                                             >
                                                {COMPAREKeys.substitutesInnerPack}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="fiftyseven"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomBOM
                                                revision={data.revision}
                                                partName={value}
                                                data={data.substitutesInnerPack["release"]}
                                                previousData={
                                                   data.substitutesInnerPack["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.substitutesInnerPack}
                                             />
                                          </div>
                                       </div>
                                    )}
                                    
                                 {!loading && data.notes && selectedItems["notes"] && (
                                    <div id="39" className="PartComparision">
                                       <Card>
                                          <Card.Body
                                             className="accordionStyle"
                                             aria-controls="thirtynine"
                                          >
                                             {COMPAREKeys.notes}{" "}
                                          </Card.Body>
                                       </Card>
                                       <div
                                          className="accordionDiv shadow"
                                          id="thirtynine"
                                          name="collapseItem"
                                          style={{ display: "block" }}
                                       >
                                          <CustomTableATS
                                             revision={data.revision}
                                             partName={value}
                                             data={data.notes["release"]}
                                             previousData={data.notes["obsolete"]}
                                             handleDiffCategory={handleDiffCategory}
                                             name={COMPAREKeys.notes}
                                          />
                                       </div>
                                    </div>
                                 )}
                                 {!loading &&
                                    data.cupArtworks &&
                                    selectedItems["cupArtworks"] && (
                                       <div id="48" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="foutyEight"
                                             >
                                                {COMPAREKeys.cupArtworks}{" "}
                                                
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="foutyEight"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomTableATS 
                                                revision={data.revision}
                                                partName={value}
                                                data={data.cupArtworks['release']}
                                                previousData={data.cupArtworks['obsolete']}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.cupArtworks}
                                             />
                                          </div>
                                       </div>
                                    )}
                                    {!loading &&
                                       data.batteryCalculation &&
                                       selectedItems["batteryCalculation"] && (
                                          <div id="47" className="PartComparision">
                                             <Card>
                                                <Card.Body
                                                   className="accordionStyle"
                                                   aria-controls="fourtySeven"
                                                >
                                                   {COMPAREKeys.batteryCalculation}{" "}
                                                </Card.Body>
                                             </Card>
                                             <div
                                                className="accordionDiv shadow"
                                                id="fourtySeven"
                                                name="collapseItem"
                                                style={{ display: "block" }}
                                             >
                                                <CustomTableATS 
                                                   revision={data.revision}
                                                   partName={value}
                                                   data={data.batteryCalculation['release']}
                                                   previousData={data.batteryCalculation['obsolete']}
                                                   handleDiffCategory={handleDiffCategory}
                                                   name={COMPAREKeys.batteryCalculation}
                                                />
                                             </div>
                                          </div>
                                       )}
                                 {!loading &&
                                    data.sapBomasFed &&
                                    selectedItems["sapBomasFed"] && (
                                       <div id="40" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="forty"
                                             >
                                                {COMPAREKeys.sapBomasFed}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="forty"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomViewPQR
                                                revision={data.revision}
                                                partName={value}
                                                data={data.sapBomasFed["release"]}
                                                previousData={
                                                   data.sapBomasFed["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.sapBomasFed}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.marketOfSale &&
                                    selectedItems["marketOfSale"] && (
                                       <div id="41" className="PartComparision">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="forty"
                                             >
                                                {COMPAREKeys.marketOfSale}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="forty"
                                             name="collapseItem"
                                             style={{ display: "block" }}
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.marketOfSale['release']}
                                                previousData={data.marketOfSale['obsolete']}
                                                releaseHeader = {data.marketOfSale['releaseDateAndTimeOfLastMOS']}
                                                obsoleteHeader = {data.marketOfSale['obsoleteDateAndTimeOfLastMOS']}
                                                // extraColumn={true}
                                                message={true}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.marketOfSale}
                                             />
                                          </div>
                                       </div>
                                    )}

                                 {!loading &&
                                    data.startingmaterials &&
                                    selectedItems["startingmaterials"] && (
                                       <div id="23" className="PartComparisionOthers">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="twentythree"
                                             >
                                                {COMPAREKeys.startingmaterials}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="twentythree"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.startingmaterials["release"]}
                                                previousData={
                                                   data.startingmaterials["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.startingmaterials}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.rdsites &&
                                    selectedItems["rdsites"] && (
                                       <div id="24" className="PartComparisionOthers">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="twentyfour"
                                             >
                                                {COMPAREKeys.rdsites}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="twentyfour"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.rdsites["release"]}
                                                previousData={data.rdsites["obsolete"]}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.rdsites}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.lifecycleApprovalPowerview &&
                                    selectedItems["lifecycleApprovalPowerview"] && (
                                       <div id="25" className="PartComparisionOthers">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="twentyfive"
                                             >
                                                {COMPAREKeys.lifecycleApprovalPowerview}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="twentyfive"
                                             name="collapseItem"
                                          >
                                             <LCDerivedTable
                                                data={
                                                   data.lifecycleApprovalPowerview[
                                                      "release"
                                                   ]
                                                }
                                                previousData={
                                                   data.lifecycleApprovalPowerview[
                                                      "obsolete"
                                                   ]
                                                }
                                                derived="Tasks/Signatures"
                                                handleDiffCategory={handleDiffCategory}
                                                name={
                                                   COMPAREKeys.lifecycleApprovalPowerview
                                                }
                                                revision={data.revision}
                                                partName={value}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.ownership &&
                                    selectedItems["ownership"] && (
                                       <div id="26" className="PartComparisionOthers">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="twentysix"
                                             >
                                                {COMPAREKeys.ownership}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="twentysix"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                data={data.ownership}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.ownership}
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}
                                 {!loading &&
                                    data.ipClasses &&
                                    selectedItems["ipClasses"] && (
                                       <div id="27" className="PartComparisionOthers">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="twentyseven"
                                             >
                                                {COMPAREKeys.ipClasses}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="twentyseven"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.ipClasses["release"]}
                                                previousData={data.ipClasses["obsolete"]}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.ipClasses}
                                             />
                                          </div>
                                       </div>
                                    )}

                                 {!loading &&
                                    data.security &&
                                    selectedItems["security"] && (
                                       <div id="28" className="PartComparisionOthers">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="twentyeight"
                                             >
                                                {COMPAREKeys.security}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="twentyeight"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.security["release"]}
                                                previousData={data.security["obsolete"]}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.security}
                                             />
                                          </div>
                                       </div>
                                    )}

                                 {!loading &&
                                    data.organizationsObject &&
                                    selectedItems["organizationsObject"] && (
                                       <div id="29" className="PartComparisionOthers">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="twentynine"
                                             >
                                                {COMPAREKeys.organizationsObject}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="twentynine"
                                             name="collapseItem"
                                          >
                                             <Attributes
                                                data={data.organizationsObject}
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.organizationsObject}
                                                partName={value}
                                                revision={data.revision}
                                             />
                                          </div>
                                       </div>
                                    )}

                                 {!loading && data.files && selectedItems["files"] && (
                                    <div id="30" className="PartComparisionOthers">
                                       <Card>
                                          <Card.Body
                                             className="accordionStyle"
                                             aria-controls="thirty"
                                          >
                                             {COMPAREKeys.files}{" "}
                                          </Card.Body>
                                       </Card>
                                       <div
                                          className="accordionDiv shadow"
                                          id="thirty"
                                          name="collapseItem"
                                       >
                                          <GenDocsFileDownTable
                                             data={data.files["release"]}
                                             previousData={data.files["obsolete"]}
                                             attributes={data.attributes}
                                             headerContent={data.headerContent}
                                             handleDiffCategory={handleDiffCategory}
                                             name={COMPAREKeys.files}
                                             revision={data.revision}
                                             partName={value}
                                          />
                                       </div>
                                    </div>
                                 )}
                                 {!loading &&
                                    data.gpsAssessment &&
                                    selectedItems["gpsAssessment"] && (
                                       <div id="31" className="PartComparisionOthers">
                                          <Card>
                                             <Card.Body
                                                className="accordionStyle"
                                                aria-controls="thirtyone"
                                             >
                                                {COMPAREKeys.gpsAssessment}{" "}
                                             </Card.Body>
                                          </Card>
                                          <div
                                             className="accordionDiv shadow"
                                             id="thirtyone"
                                             name="collapseItem"
                                          >
                                             <CustomTableATS
                                                revision={data.revision}
                                                partName={value}
                                                data={data.gpsAssessment["release"]}
                                                previousData={
                                                   data.gpsAssessment["obsolete"]
                                                }
                                                handleDiffCategory={handleDiffCategory}
                                                name={COMPAREKeys.gpsAssessment}
                                             />
                                          </div>
                                       </div>
                                    )}

                                 {selectedItems["message"] && (
                                    <p className="errorMsgStyle">{PREF_MSG}</p>
                                 )}
                              </Col>
                           </Row>
                        </Col>
                     </Row>
                  ) : (
                     ""
                  )}
               </Container>
            </CSSTransition>
         )}
      </React.Fragment>
   )
   function setNavigation() {
      var sideNavObj = "";
      var sideNavObjOther = "";
      setTimeout(function getNavData() {
         sideNavObj = document.getElementsByClassName("PartComparision");
         sideNavObjOther = document.getElementsByClassName("PartComparisionOthers");
         let firstAvailableElement = null;
         Array.from(sideNavObj).forEach((element) => {
            if (element.id === "0") {
               firstAvailableElement = element;
            }
         });
         if (!firstAvailableElement && sideNavObj.length > 0) {
            const sortedElements = Array.from(sideNavObj).sort((a, b) => {
               return parseInt(a.id) - parseInt(b.id);
            });
            firstAvailableElement = sortedElements[0];
         }
         Array.from(sideNavObj).forEach((element) => {
            element.style.display = "none";
         });
   
         Array.from(sideNavObjOther).forEach((element) => {
            element.style.display = "none";
         });
         if (firstAvailableElement) {
            firstAvailableElement.style.display = "block";
         }
         setSideNav(sideNavObj);
         setSideNavOthers(sideNavObjOther);
      }, 1000);
   }
}
export default PartComparison
